import { call, put } from "redux-saga/effects";

import { api, notify } from "services";
import { ICreateRequest } from "interfaces/chk_cpf";

import { requestErrorHandler } from "utils";
import { ChkCpfActions } from "store/ducks/booking";

export function* ChkCpfRequest(action: any) {
  const { cpf, onSuccess, onFailure } = action as ICreateRequest;

  try {
    const response = yield call(api.get, "/consulta", {
      params: { cpf },
    });

    if (response.status !== 200) {
      throw new Error("O cpf informado é inválido");
    }

    const { data } = response;
    yield put(ChkCpfActions.success(data));
    if (onSuccess) onSuccess(data);
  } catch (error: any) {
    const isInvalidCpf =
      Boolean(error.response) || error.message === "O cpf informado é inválido";
    const errorMessage = isInvalidCpf
      ? "O cpf informado é inválido"
      : requestErrorHandler(error).errorMessage;

    notify("error", errorMessage);
    yield put(ChkCpfActions.failure(errorMessage));
    if (onFailure) onFailure();
  }
}
